import { useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router";
import { afterAuthPath } from "../after-auth.ts";
import { api, ApiError } from "../api.ts";
import { usePageMeta } from "../components/Layout.tsx";
import { useSession } from "../session.tsx";

export function Login() {
  usePageMeta("Sign in", "Sign in to Coding with your gazar.dev account.");
  const { signedIn } = useSession();
  const navigate = useNavigate();
  // Where the guard bounced them from, so opening a link to a specific problem
  // while signed out lands on that problem rather than on whatever the
  // scheduler would have picked.
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const { user } = await api.login(email, password);
      signedIn(user);
      navigate(afterAuthPath(from));
    } catch (cause) {
      setError(
        cause instanceof ApiError && cause.status === 401
          ? "That email and password did not match."
          : cause instanceof ApiError && cause.status === 429
            ? "Too many attempts. Wait a few minutes and try again."
            : "Could not reach the server. Try again in a moment.",
      );
      setBusy(false);
    }
  };

  return (
    <div className="form-page">
      <form className="panel form" onSubmit={submit}>
        <h1>Sign in</h1>
        <p className="muted">
          The same account as gazar.dev. If you have one there, it works here.
        </p>
        <label>
          <span>Email</span>
          <input
            type="email"
            value={email}
            autoComplete="username"
            required
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label>
          <span>Password</span>
          <input
            type="password"
            value={password}
            autoComplete="current-password"
            required
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        {error && <p className="error">{error}</p>}
        <button className="primary" type="submit" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <p className="muted small">
          No account? <Link to="/signup">Create one</Link>.
        </p>
      </form>
    </div>
  );
}
